import { View } from 'react-native'
import Icon from '@ui/elements/Icon'
import Typography from '@ui/typography'
import { colors } from '@ui/colors'

interface Props {
  version: string | undefined
}

export default function VersionIcon({ version }: Props) {
  return (
    <View className="flex h-24 flex-col items-center justify-between pb-4">
      <Icon
        name="arrow-down"
        size={48}
        strokeWidth={2}
        color={colors.white}
        className="relative -top-1 left-0"
      />
      <View
        className="flex h-8 items-center justify-center rounded-sm bg-white px-3"
        style={{ minWidth: 80 }}
      >
        <Typography variant="MDB" className="text-center tracking-widest">
          {version || '• • •'}
        </Typography>
      </View>
    </View>
  )
}
